/**
 * StorageManager
 * Simple manager for Storages.
 * i.e. when the application requires more scopes,
 * register a Storage for every scope in the manager with
 * a specific scope key.
 */
var StorageManager = /** @class */ (function () {
    function StorageManager() {
        this.storages = {};
    }
    StorageManager.prototype.register = function (key, storage) {
        if (key in this.storages) {
            throw Error(key + " already registered");
        }
        this.storages[key] = storage;
    };
    StorageManager.prototype.get = function (key) {
        return key in this.storages ? this.storages[key] : null;
    };
    /**
     * getAll
     * Obtain all registered Storage instances array
     */
    StorageManager.prototype.getAll = function () {
        var _this = this;
        return Object.keys(this.storages).map(function (key) { return _this.storages[key]; });
    };
    StorageManager.prototype.remove = function (key) {
        if (key in this.storages) {
            delete this.storages[key];
        }
    };
    return StorageManager;
}());
export default StorageManager;
//# sourceMappingURL=StorageManager.js.map